import { FC } from "react";

import { ReportTableHeadDiagrams } from "../parts";

export const ReportDiagramsInner: FC = () => {
  return <ReportTableHeadDiagrams />;
};
